/**
 * Manager Notifications System.
 *
 * Поллинг непрочитанных уведомлений каждые 30 секунд. Окно уведомлений
 * позиционируется относительно иконки в правом верхнем углу.
 */

import { apiRequest } from '../../api.js';

async function loadNotificationsCount() {
    try {
        const response = await apiRequest('/manager/notifications', { method: 'GET' });
        if (response && response.success) {
            updateNotificationCount(response.count);
            updateNotificationsList(response.notifications);
        }
    } catch (e) {
        // Тихо глотаем — не хотим spam-toast на каждую проблему сети
        console.error('Error loading manager notifications:', e);
    }
}

function updateNotificationCount(count) {
    const badge = document.getElementById('notificationCount');
    if (!badge) return;

    if (count > 0) {
        badge.textContent = count;
        badge.style.display = '';
    } else {
        badge.style.display = 'none';
    }
}

function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
}

function updateNotificationsList(notifications) {
    const list = document.getElementById('notificationsList');
    if (!list) return;

    if (!notifications || notifications.length === 0) {
        list.innerHTML = '<div class="adm_noti_window_item"><span class="adm_noti_window_item_caption">No new notifications</span></div>';
        return;
    }

    list.innerHTML = notifications.map(n => `
        <div class="adm_noti_window_item" data-notification-id="${escapeHtml(String(n.id))}">
            <span class="adm_noti_window_item_caption">${escapeHtml(n.message)}</span>
            <a class="adm_noti_window_item_link" href="${escapeHtml(n.link)}" data-notification-id="${escapeHtml(String(n.id))}">View more</a>
        </div>
    `).join('');
}

function toggleNotificationWindow() {
    const notifWindow = document.getElementById('notificationWindow');
    const icon = document.getElementById('notificationIcon');
    if (!notifWindow || !icon) return;

    const isVisible = notifWindow.offsetWidth > 0 && notifWindow.offsetHeight > 0;

    if (isVisible) {
        notifWindow.style.display = 'none';
        return;
    }

    // Позиционируем справа от иконки
    const iconRect = icon.getBoundingClientRect();
    const rightPosition = document.documentElement.clientWidth - iconRect.right;
    notifWindow.style.right = rightPosition + 'px';
    notifWindow.style.top = '60px';
    notifWindow.style.display = 'block';

    loadNotificationsCount();
}

async function markAsRead(notificationId) {
    try {
        const response = await apiRequest(`/manager/notifications/${notificationId}/read`, { method: 'POST' });
        if (response && response.success) {
            loadNotificationsCount();
        }
    } catch (e) {
        console.error('Error marking notification as read:', e);
    }
}

function initManagerNotifications() {
    const icon = document.getElementById('notificationIcon');
    if (!icon) return; // нет иконки — не на странице менеджера

    loadNotificationsCount();
    setInterval(loadNotificationsCount, 30000);

    icon.addEventListener('click', e => {
        e.preventDefault();
        toggleNotificationWindow();
    });

    // Закрыть окно при клике вне
    document.addEventListener('click', e => {
        const notifWindow = document.getElementById('notificationWindow');
        if (!notifWindow) return;
        if (!e.target.closest('#notificationWindow, #notificationIcon')) {
            notifWindow.style.display = 'none';
        }
    });

    // Клик по ссылке "View more" внутри notification — mark as read
    document.addEventListener('click', e => {
        const link = e.target.closest('.adm_noti_window_item_link[data-notification-id]');
        if (link) {
            markAsRead(link.dataset.notificationId);
            // Не preventDefault — пусть браузер перейдёт по href
        }
    });
}

// Публичный API для inline-скриптов и совместимости
window.markAsRead = markAsRead;
window.loadNotificationsCount = loadNotificationsCount;

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initManagerNotifications);
} else {
    initManagerNotifications();
}
